import React, { useState, useEffect, useCallback } from 'react'
import { BasicDropdown } from '..'
import qs from 'querystring'
import { useHistory, useLocation } from 'react-router-dom'
import { formUpdater, inputNormalizer } from '../../utils'
import { FormSystem } from './filter-form-system'
import { useSystem } from '../../features/system/hook'
import { useDispatch, useSelector } from 'react-redux'
import FormKeyword from '../../features/search/components/form-keyword'
import { ProvincesProvider } from '../../features/provinces/hook'
import { ProvinceDropdown } from '../../features/provinces/components/province-dropdown'
import { CitiesProvider } from '../../features/cities/hook'
import { CityDropdown } from '../../features/cities/components/city-dropdown'
import { setQueryString } from '../../features/search/slice'
import { DateFilter } from '../date-filter'
import { useInternationalization } from '../../features/i18n'
import { SelectCheckbox } from '../dashboard-form'

let flag = false

const FilterForm = ({
  query,
  options = {
    keyword: true,
    location: true,
    type: true,
    date: true,
    category: false,
    category_resource: false,
    type_resource: false,
  }
}) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const {
    approachOptions,
    issueOptions,
    organizationTypeOptions,
    categoryResourceOptions,
    categoryBlogOptions,
    typeResourceOptions
  } = useSystem()

  const [form, setForm] = useState({})
  const { translate } = useInternationalization()
  const { selectedAudienceId } = useSelector(state => state.system)

  const renderQueries = useCallback((query) => {
    let result = generateInitialResult()

    function pushToResult(options, id, key){
      const data = options.find(a => a.value === parseInt(id))
      if(data) result[key] = [...result[key], data]
    }

    const optionsBank = {
      // form key: array of options values
      approach: approachOptions,
      issue: issueOptions,
      type: organizationTypeOptions,
      category: categoryBlogOptions,
      typeResource: typeResourceOptions
    }

    let options = []

    for(let k in query){
      if(optionsBank[k]){
        options = optionsBank[k]
      }

      if(k === 'province'){
        result[k] = query[k]
      } else {
        if(query[k]){
          // Single value
          if(typeof query[k] === 'string'){
            const id = query[k]
            pushToResult(options, id, k)
          }
          // Array value
          else if(typeof query[k] === 'object' && query[k].length > 0) {
            for (let index = 0; index < query[k].length; index++) {
              const id = query[k][index];
              pushToResult(options, id, k)
            }
          }
        }
      }
    }

    setForm(result)
  }, [approachOptions, issueOptions, organizationTypeOptions, categoryBlogOptions, typeResourceOptions])

  useEffect(() => {
    // change query to react select's options format
    renderQueries(query)
  }, [query, renderQueries])

  const updateForm = (e) => formUpdater(e, form, setForm)

  const updateProvince = (e) => {
    setForm({
      ...form,
      city: {}
    })

    setTimeout(() => {
      flag = true
      updateForm(e)
    }, 100)
  }

  const updateCity = (e) => {
    console.log('updateCity', e)
    setForm({
      ...form,
      city: {}
    })

    setTimeout(() => {
      flag = true
      updateForm(e)
    }, 100)
  }

  const handleMulti = (e, key) => {
    flag = true

    if(e === null){
      inputNormalizer([], key, updateForm)
    } else {
      // const ids = e.map(s => s.id ? s.id : s.value)
      const ids = e
      inputNormalizer(ids, key, updateForm)
    }
  }

  const handleFormChange = useCallback((form) => {
    const formIds = convertOptionsToIds(form)

    // Inject 'typeAudience'
    if(selectedAudienceId && selectedAudienceId !== 1 && !formIds.audience){
      formIds.audience = [selectedAudienceId]
    }

    const searchString = qs.stringify(formIds)
    const currentPath = location.pathname

    history.replace({
      pathname: currentPath,
      search: '?'+searchString
    })
  }, [history, location, selectedAudienceId])

  const handleSearchSubmit = (keyword) => {
    console.log(keyword)
    const currentPath = location.pathname

    if(keyword && keyword.length > 0){
      const newQueryString = '?keyword='+keyword
      history.replace({
        pathname: currentPath,
        search: newQueryString
      })
      dispatch(setQueryString(newQueryString))
    } else {
      history.replace({ pathname: currentPath })
      dispatch(setQueryString(''))
    }
  }

  useEffect(() => {
    if(flag === true){
      flag = false
      handleFormChange(form)
    }
  }, [form, handleFormChange])

  const handleDate = ({maxDate, minDate}) => {
    if(maxDate && minDate){
      const query = qs.parse(location.search)
      const newQuery = {
        ...query,
        startRentangWaktu: minDate,
        endRentangWaktu: maxDate
      }
      const stringified = qs.stringify(newQuery)
      let search = ''

      if(stringified.slice(0,3) === '%3F'){
        search = stringified.substring(3, stringified.length-1)
      }

      console.log({search})

      history.push({
        pathname: location.pathname,
        search
      })
    }
  }

  return (
    <div>
      {
        options.keyword &&
        <div className="mb-8">
          <p className="font-bold text-sm mb-4">
            {translate('SEARCH', 'search_by_keyword')}
          </p>
          <FormKeyword defaultValue={query?.keyword} onSubmit={(keyword) => handleSearchSubmit(keyword)} />
        </div>
      }

      {
        options.category &&
        <div className="mb-8">
          <p className="font-bold text-sm mb-4">
            {translate('SEARCH', 'categories')}
          </p>
          <BasicDropdown
            placeholder={translate('SEARCH', 'categories')}
            multi
            options={categoryBlogOptions}
            value={form.category || []}
            onChange={(e) => handleMulti(e, 'category')}
          />
        </div>
      }

      {
        options.category_resource &&
        <div className="mb-8">
          <p className="font-bold text-sm mb-4">
            {translate('SEARCH', 'categories')}
          </p>
          <BasicDropdown
            placeholder={translate('SEARCH', 'categories')}
            multi
            options={categoryResourceOptions}
            value={form.category || []}
            onChange={(e) => handleMulti(e, 'category')}
          />
        </div>
      }

      {
        options.location &&
        <div className="mb-8">
          <p className="font-bold text-sm mb-4">
            {translate('SEARCH', 'location')}
          </p>

          <ProvincesProvider>
            <ProvinceDropdown
              defaultValue={typeof form.province === 'string' ? {label: form.province, value: form.province} : form.province?.value}
              updateForm={updateProvince}
              customLabel={<></>}
            />
          </ProvincesProvider>

          {
            (form.province !== null) ? (
              <CitiesProvider provinceId={typeof form.province === 'string' ? form.province : form.province?.value}>
                <CityDropdown
                  defaultValue={{label: form.city, value: form.city}}
                  updateForm={updateCity}
                  customLabel={<></>}
                />
              </CitiesProvider>
            ) : (
              <>
                <BasicDropdown
                  placeholder={translate('GENERAL', 'city_choose')}
                  options={[]}
                  disabled={true}
                />
              </>
            )
          }
        </div>
      }

      {
        options.type_resource &&
        <div className="mb-8">
          <p className="font-bold text-sm mb-4">
            {translate('SEARCH', 'resource_type')}
          </p>
          {
            (typeResourceOptions && typeResourceOptions.length > 0) &&
            <SelectCheckbox
              className="text-sm"
              options={typeResourceOptions}
              value={form.typeResource || []}
              placeholder={translate('SEARCH', 'resource_type')}
              onChange={(e) => handleMulti(e, 'typeResource')}
            />
          }
        </div>
      }

      {
        options.type &&
        <FormSystem initialForm={form} handleMulti={handleMulti}/>
      }

      {
        options.date &&
        <div>
          <p className="font-bold text-sm mb-4">
            {translate('SEARCH', 'date')}
          </p>
          <div className="date-filter-wrapper relative">
            <DateFilter onSubmit={handleDate}/>
          </div>
        </div>
      }
    </div>
  )
}

// Helpers
function generateInitialResult() {
  return {
    approach: [],
    issue: [],
    type: [],
    category: [],
    province: null,
    city: [],
    audience: [],
    typeResource: []
  }
}

export function convertOptionsToIds(form) {
  const query = form
  let result = generateInitialResult()

  function pushToResult(id, key){
    if(id) {
      if(!result[key]){
        result[key] = [id]
      } else {
        result[key] = [...result[key], id]
      }
    }
  }

  for(let k in query){
    if(query[k]){
      // Single value
      if(typeof query[k] === 'string'){
        pushToResult(query[k], k)
      }
      // Array value
      else if(typeof query[k] === 'object' && query[k].length > 0) {
        for (let index = 0; index < query[k].length; index++) {
          const data = query[k][index];
          if(data && data !== null){
            pushToResult(data.value, k)
          }
        }
      }

      // Object value
      else if(typeof query[k] === 'object' && query[k].value) {
        const data = query[k]
        pushToResult(data.value, k)
      }
    }
  }

  // filter empty value
  let filtered = {}
  for(let kk in result){
    if(kk !== "" && result[kk] && result[kk].length > 0){
      filtered[kk] = result[kk]
    }
  }

  return filtered
}

export { FilterForm }
